import { colors, fonts } from '../css';

export const muiGlobalTheme = {
  palette: {
    action: { disabled: colors.colorGrey04 },
    primary: { main: colors.colorBlue, dark: colors.colorBlue },
    text: { disabled: colors.colorGrey03, primary: colors.colorGrey03, secondary: colors.colorBlue }
  },
  typography: { fontFamily: fonts.fontRegular, fontSize: 15, useNextVariants: true },
  overrides: {
    MuiIconButton: {
      root: {
        marginBottom: 0
      }
    },
    MuiFormControlLabel: { root: { fontSize: 15 } },
    MuiFormHelperText: { root: { fontSize: 12 } },
    MuiInput: {
      underline: 'none'
    },
    MuiFilledInput: {
      root: {
        backgroundColor: colors.colorGrey05,
        '&$disabled': {
          backgroundColor: colors.colorGrey05 // You may want to ensure the background color remains consistent
        }
      },
      input: {
        color: colors.colorGrey02,
        '&$disabled': {
          color: colors.colorGrey02
        }
      },
      underline: {
        borderBottom: 'none'
      },
      disabled: {}
    },
    MuiSwitch: {
      root: {
        width: 42,
        padding: 0,
        margin: 1
      },
      thumb: {
        width: 24,
        height: 24
      },
      track: {
        borderRadius: 26 / 2,
        border: `1px solid ${colors.colorGrey03}`,
        backgroundColor: colors.colorGrey05
      }
    }
  }
};
